import { gql } from 'apollo-angular';
import { DocumentNode } from 'graphql';

export const getInstallers: DocumentNode = gql`
  query getInstallers($location: JSON!) {
    supplierDistances(
      location: $location
      filter: { supplierTypeId: 9, available: true }
      orderBy: name_ASC
    ) {
      id
      name
      distance
      supplierScore {
        supplierId
        color
      }
      supplierHolidays {
        id
        startDate
        endDate
      }
    }
  }
`;
